module.exports = __webpack_public_path__ + "static/media/product_06.16f62576.jpg";